var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20H18C19.1 20 20 19.1 20 18V10C20 4.48 15.52 0 10 0ZM10 18C7.11 18 4.57 16.46 3.17 14.16L6.12 11.21L9.41 14L14 9.42V11H16V6H11V8H12.58L9.3 11.28L6 8.5L2.31 12.2C2.11 11.5 2 10.76 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM17.5 18.5C16.95 18.5 16.5 18.05 16.5 17.5C16.5 16.95 16.95 16.5 17.5 16.5C18.05 16.5 18.5 16.95 18.5 17.5C18.5 18.05 18.05 18.5 17.5 18.5Z",
    fill: "#22232B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.b7c5e5982de4a3e974fe5045784d9589.svg";
export { ForwardRef as ReactComponent };